import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { AuthForm } from "../AuthForm";
import { useEmailAuth } from "../../hooks/useEmailAuth";
import { HANDOFF_PATH } from "../../lib/sandboxDraft";

export const AuthModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const auth = useEmailAuth({ onSuccess: () => { onClose(); navigate(HANDOFF_PATH, { replace: true }); } });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sbx-auth-modal" data-testid="sandbox-auth-modal">
        <DialogTitle className="sr-only">Sign in to dispatch your job</DialogTitle>
        <DialogDescription className="text-xs text-muted mb-3">Sign in (or create an account) and your demo job is waiting in the real form. 10 free credits, no card.</DialogDescription>
        <AuthForm auth={auth} compact />
      </DialogContent>
    </Dialog>
  );
};
